module.exports = __webpack_public_path__ + "img/block-happy.53769929.jpg";